/**
 * `modules/action/initSubmenu.js`
 *  - サブメニューのイベント管理（クリック・ホバー対応）
 *
 * 使用方法:
 *  - import {initSubmenu} from "../modules/action/initSubmenu.js";
 *  - initSubmenu(button, listeners);
 */

import {mediaQuery} from "../../utils/index.js";

export function initSubmenu(button, listeners) {
  const commonTrigger = button.dataset.submenuTrigger;
  const pcTrigger = button.dataset.submenuTriggerPc || commonTrigger;
  const spTrigger = button.dataset.submenuTriggerSp || commonTrigger;
  const trigger = mediaQuery() === "pc" ? pcTrigger : spTrigger;
  if (trigger === "none") return;

  const childMenu = document.querySelector(`[data-submenu-child="${button.dataset.submenuParent}"]`);
  if (!childMenu) return;
  const childMenuLink = childMenu.querySelectorAll('a');

  /** サブメニューの開閉処理 */
  const toggleSubMenu = (e) => {
    e.preventDefault();
    const isOpen = childMenu.classList.toggle("is-open");
    button.classList.toggle("is-active", isOpen);
    e.stopPropagation();
  };

  const openSubMenu = () => {
    childMenu.classList.add("is-open");
    button.classList.add("is-active");
  }
  const closeSubMenu = () => {
    childMenu.classList.remove("is-open");
    button.classList.remove("is-active");
  }

  if (trigger === "hover" && mediaQuery() === "pc") {
    button.addEventListener("mouseover", openSubMenu);
    button.addEventListener("mouseout", closeSubMenu);
    listeners.push([button, "mouseover", openSubMenu]);
    listeners.push([button, "mouseout", closeSubMenu]);
  } else if (trigger === "click") {
    button.addEventListener("click", toggleSubMenu);
    listeners.push([button, "click", toggleSubMenu]);
  }

  // サブメニュー内の各リンククリック時の挙動
  childMenuLink.forEach((link) => {
    link.addEventListener("click", closeSubMenu);
    listeners.push([link, "click", closeSubMenu]);
  });
}